import { createSlice } from '@reduxjs/toolkit'


export interface UtilityType {
    isCheckboxChecked: boolean;
}

const initialState: UtilityType = {
    isCheckboxChecked: false,
}

export const UtilitySlice = createSlice({
    name: 'UtilitySlice',
    initialState,
    reducers: {


        setCheckboxChecked: (state, action) => {
            state.isCheckboxChecked = action.payload;
        },

    },
})

export const { setCheckboxChecked } = UtilitySlice.actions

export default UtilitySlice.reducer

